import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-23/task-03";

const task: Slide = {
  title: "Active crossover filters...",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
